import { render } from "./ActivitySalesCategoryPage.vue?vue&type=template&id=53c523a6"
import script from "./ActivitySalesCategoryPage.vue?vue&type=script&lang=js"
export * from "./ActivitySalesCategoryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem});
